export default __webpack_public_path__ + "static/media/settings_room_device_focus.d75ac49c.svg";